type ApplicationEventProperties = {
  application_id: string;
};

export const getApplicationEventProperties = (
  applicationId?: string
): ApplicationEventProperties | undefined => {
  if (!applicationId) {
    return undefined;
  }

  return {
    application_id: applicationId,
  };
};
